function init() {
    let toggleEl = document.querySelectorAll(".accordion-heading");

    if (toggleEl) {
        toggleEl.forEach(element => {
            element.addEventListener("click", () => {
                let accordionBody = element.parentElement;

                document.querySelectorAll(".accordion-body").forEach(body => {
                    if (body.parentElement !== accordionBody) {
                        body.parentElement.classList.add("closeBody");
                    }
                });

                accordionBody.classList.toggle("closeBody");
            });
        });
    }
}

export default { init };
